var render = function render(){var _vm=this,_c=_vm._self._c;return _c('container',[_c('row',{staticClass:"mb-8",attrs:{"wrap":""}},_vm._l((_vm.items),function(item,index){return _c('column',{key:index,staticClass:"w-full md:w-1/2 xl:w-1/3"},[_c('info-box',_vm._b({},'info-box',item,false))],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }